/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container.kids[_ngcontent-%COMP%]{font-family:\"Patrick Hand\";font-size:1.3rem}.red[_ngcontent-%COMP%]{color:#ff3232}"];
export { styles as styles };
